import {
    usersProfileInfoFulfilledConstants,
    usersProfileInfoRejectedConstants,
    usersProfileInfoPendingConstants
} from '../actions';

const initialState = {
    profiles: {},
};

export default function (state = initialState, { type = '', payload = {}, meta }) {
    switch (type) {
        case usersProfileInfoPendingConstants.USERS_PROFILE_INFO_LOADED: {
            return {
                ...state,
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        isLoading: true,
                        error: ''
                    },
                },
            };
        }
        case usersProfileInfoFulfilledConstants.USERS_PROFILE_INFO_LOADED: {
            if (!payload.data) return state;

            const validData = {};
            for (const [key, value] of Object.entries(payload.data)) {
                validData[`${key}`] = value;
            }
            /**
             *  @param {{workload:number}} data
             */
            validData.assignments && validData.assignments.sort((a, b) => b.workload - a.workload);

            const namesPMs = validData?.assignments?.map(item => {
                const assignedPMs =
                    validData?.projects?.find(project => project.projectName === item.to)?.pms;

                return { ...item, assignedPMs };
            }) ?? [];

            return {
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        ...validData,
                        assignments: namesPMs,
                        isLoading: false,
                        error: '',
                    },
                },
            };
        }
        case usersProfileInfoRejectedConstants.USERS_PROFILE_INFO_LOADED: {

            return {
                ...state,
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        isLoading: false,
                        error: payload.response ? `${payload.response.data.errorMessage || payload.response.status + ' ' + payload.response.statusText}` :
                            payload.message
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
}
